export const xlarge = '@media (min-width: 1600px)'
export const large = '@media (min-width: 1300px) and (max-width: 1599px)'
export const medium = '@media (min-width: 768px) and (max-width: 1299px)'
export const small = '@media (max-width: 767px)'
